// extracted by mini-css-extract-plugin
export var link = "_tb-0";